import { ProductType } from '../../common';
import { ProductTypeUrlParameter, ProductTypeUrlParameterIndex } from '../models';

export const getProductTypeUrlParameter = (
  productType: ProductType = ProductType.Family
): ProductTypeUrlParameterIndex => {
  const parameterMapping: Record<ProductType, ProductTypeUrlParameterIndex> = {
    [ProductType.Group]: ProductTypeUrlParameter.Group,
    [ProductType.Product]: ProductTypeUrlParameter.Product,
    [ProductType.Family]: ProductTypeUrlParameter.Family,
  };

  return parameterMapping[productType] ?? ProductTypeUrlParameter.Family;
};
